interface DirectoryAdminCandidate {
    __typename?: string;
    IsStaffAdmin?: boolean | null;
    IsHighAdmin?: boolean | null;
}

/**
 * Whether the member may add a project to the directory or pin it to the
 * top: staff admins and high admins. Nobody else is shown either toggle.
 */
export const isDirectoryAdmin = (user: DirectoryAdminCandidate): boolean =>
    user.__typename === 'Me' &&
    (user.IsStaffAdmin === true || user.IsHighAdmin === true);
